import { Component } from '@angular/core';

@Component({
  selector: 'nb-forms-test',
  templateUrl: 'forms-test.component.html',
})

export class NbFormsTestComponent {
}



// WEBPACK FOOTER //
// ./src/app/forms-test/forms-test.component.ts